import { Link } from "react-router";
import { SCHRIJVEN_TASK_TYPES, SCHRIJVEN_TASK_LABELS, type SchrijvenTaskType } from "@a2/core";
import { ModeHero } from "./ModeHero";
import { DrillCard } from "./DrillCard";
import { Divider } from "./Divider";
import type { SchrijvenMode } from "../../lib/exam-start";
import { useT } from "../../lib/use-t";

type Props = {
  selected: SchrijvenMode;
  onSelect: (m: SchrijvenMode) => void;
  disabled: boolean;
};

export function SchrijvenModeBody({ selected, onSelect, disabled }: Props) {
  const t = useT();
  return (
    <div className="space-y-4">
      <ModeHero
        selected={selected === "exam"}
        onSelect={() => onSelect("exam")}
        disabled={disabled}
        eyebrow={t("oefenen.schrijven.heroEyebrow")}
        title={t("oefenen.schrijven.heroTitle")}
        description={t("oefenen.schrijven.heroDescription")}
      />

      <Divider label={t("oefenen.divider.schrijven")} />

      <div className="grid grid-cols-2 gap-3">
        {SCHRIJVEN_TASK_TYPES.map((task: SchrijvenTaskType, i) => (
          <DrillCard
            key={task}
            num={i + 1}
            title={SCHRIJVEN_TASK_LABELS[task]}
            selected={selected === task}
            onSelect={() => onSelect(task)}
            disabled={disabled}
          />
        ))}
      </div>

      <div className="flex flex-wrap gap-x-6 gap-y-2 pt-2">
        <Link
          to="/schrijven/leren"
          className="text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
        >
          {t("schrijven.home.learnHowExamWorks")} →
        </Link>
        <Link
          to="/schrijven/geschiedenis"
          className="text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
        >
          {t("schrijven.home.viewHistory")} →
        </Link>
      </div>
    </div>
  );
}
